import en from './en';
import no from './no';

export default {
  en,
  'nb-NO': no,
};



// WEBPACK FOOTER //
// ./src/app/numberFormats/index.js